export default __webpack_public_path__ + "static/media/1988.fff1b891.png";